// Named register themes share one identity across navigation, previews and controls.
// Brand accents must not replace the semantic inspection/status palette.
export const REGISTER_THEMES = [
  {
    key: 'default', name: 'EXREG', logoUrl: null, faviconUrl: '/icon.png', logoAspect: 'square',
    primary: '#1f6fb2', dark: '#155487', soft: '#e8f2fb', headingColor: '#155487',
    navBackground: '#0b1220', accent: '#f1d212', rgb: '31, 111, 178', background: '#f4f7fa',
  },
  {
    key: 'orlen', name: 'ORLEN', logoUrl: '/branding/orlen-logo.jpg',
    faviconUrl: '/branding/orlen-logo.jpg', logoAspect: 'square',
    primary: '#D81E04', dark: '#AD1803', soft: '#FCECE9', headingColor: '#a92010',
    navBackground: '#202124', accent: '#D81E04', rgb: '216, 30, 4', background: '#f5f5f6',
  },
  {
    key: 'bumi-armada', name: 'Bumi Armada', logoUrl: '/branding/bumi-armada-logo.png',
    faviconUrl: '/branding/bumi-armada-favicon.png', logoAspect: 'wide',
    primary: '#232e83', dark: '#1a2262', soft: '#eeeff9', headingColor: '#232e83',
    navBackground: '#17213e', accent: '#1fb25a', rgb: '35, 46, 131', background: '#f4f6fa',
  },
];

export const getRegisterBrand = (key) => REGISTER_THEMES.find((brand) => brand.key === key) || REGISTER_THEMES[0];
export const normalizeRegisterTheme = (key) => getRegisterBrand(key).key;
